// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"48c29d75","338":"58f92890","425":"b87783e0","731":"a7f561c5","757":"2d133844","804":"75a0e88a"}[chunkId] + ".chunk.js";
};